import React from 'react';
import { Link, withRouter } from "react-router-dom"
import {Input,Form,FormGroup,Label} from "reactstrap";
import { getStorageUser } from '../../../helpers/api_helper';
const Columns = ( addUpd, destroy, active) => {
	const authUser = getStorageUser();
/*
	if (authUser.id != row.administrator_id) {
		let admin_name = {
			id: 'admin_name',
			name: 'Administrador',
			selector: row => row.admin_name,
			sortable: true,
			wrap: true,
			width:'40%'
		}
	}else{

	}
*/
	let columns = [
		{
			id: 'name',
			name: 'Nombre',
			selector: row => row.name,
			sortable: true,
			wrap: true,
		},
		{
			id: 'provider',
			name: 'Proveedor',
			selector: row => row.provider?.name,
			sortable: true,
			wrap: true,

		},
		{
			id: 'admin',
			name: 'Administrator',
			selector: row => row?.administrator?.email,
			sortable: true,
			wrap: true,

		},
		{
			id: 'activo',
			name: 'Activo',
			width:'15%',
			cell: row => (
				<div className="d-flex justify-content-between">
				<FormGroup switch>
				<Input type="switch"  defaultChecked={row.active}
				onClick={() => {active(row)}}/>
				</FormGroup>
				</div>
				)
		},
		{
			id: 'actions',
			name: 'Acciones',
			width:'15%',
			button: true,
			cell: row => (
				<div className="d-flex justify-content-between">
					<div className="p-2">
						<Link to={`/routes/${row.id}`} className="btn btn-info btn-sm" title='Detalle de Ruta'>
							<i className="fa fa-eye"></i>
						</Link>
					</div>
					<div className="p-2">
						<button className="btn btn-primary btn-sm" title='Editar Ruta' onClick={() => addUpd(row)}><i className="fas fa-edit"></i></button>
					</div>
					<div className="p-2">
						<button className="btn btn-danger btn-sm" title='Eliminar Ruta' onClick={() => destroy(row.id)}><i className="fas fa-trash"></i></button>
					</div>
				</div>
				),
		}
		];
	return columns;
}

export default Columns;